import { Timestamp } from '@firebase/firestore-types';
import { OrderType } from './data';

export interface Order {
  id?: string;
  restaurant_id: string;
  restaurant: Restaurant;
  restaurant_promotion?: Restaurant;
  bill_status: string;
  payment_method: PaymentMethod;
  order_table_number: string;
  order_id: string;
  order_create_time: Timestamp;
  order_username: string;
  ordered_by?: string;
  session_id?: string;
  order_status: OrderItemStatus;
  order_delivered_time: Timestamp;
  foods: OrderItem[];
  promotion_restaurant_id: string;
  promotion_foods: OrderItem[];
  type?: string;
  food_order_status?: string;
  food_promotion_order_status?: string;
  rider_id?: string;
  seat_type: string;
  seat_number: string;
  has_damaged_order?: boolean;
  is_damaged?: boolean;
  damaged_number?: number;
  parent_id?: string;
  is_pre_order?: boolean;
  requested_delivery_time?: Timestamp;
  delivery_request?: string;
  multi_orders?: MultiOrderSegment[];
  email_or_phone?: string;
  email?: string;
  phone?: string;
  stadium_id?: string;
  gift_info?: IGiftInfo;
  order_type?: OrderType;
}

export interface IGiftInfo {
  delivery_date?: string;
  receiver_name?: string;
  receiver_email?: string;
  receiver_phone?: string;
}

export interface MultiOrderSegment {
  restaurant_id: string;
  status: string;
  rider_id?: string;
}

export interface OrderItem {
  item_customize_settings: { name: string; price: string }[];
  item_food_id: string;
  item_name: number;
  item_note: string;
  item_price: number;
  item_quantity: number;
  item_subtotal: number;
  status: string;
  item_deleted_quantity?: number;
  restaurantId?: string;
}

export interface ICreateOrder {
  bill_status: string;
  foods: OrderItem[];
  order_create_time: Timestamp;
  order_status: string;
  order_table_number: string;
  ordered_by: string;
  session_id: string;
  payment_method: PaymentMethod;
  promotion_foods: OrderItem[];
  restaurant_id: string;
  rider_id?: string;
  seat_number: string;
  seat_type: string;
  has_damaged_order?: boolean;
  is_damaged?: boolean;
  parent_id?: string;
  stadium_id?: string;
  requested_delivery_time?: Timestamp;
  order_type?: string;
  is_pre_order?: boolean;
}

export interface Restaurant {
  restaurant_id: string;
  restaurant_active?: string;
  region: string;
  restaurant_open_state?: number;
  name: string;
}

export interface FoodDetails {
  [food_id: string]: {
    name: string;
    image_url: string;
    description: string;
    customize_group_settings: {
      name: string;
      price: number;
    }[];
  };
}

export enum TabValue {
  NEW_ORDER = 'new order',
  ONGOING = 'ongoing',
  DELIVERED = 'delivered',
}

export enum OrderItemStatus {
  PREPARING = 'PREPARING',
  DELIVERING = 'DELIVERING',
  READY_FOR_PICK_UP = 'READY_FOR_PICK_UP',
  DELIVERED = 'DELIVERED',
  DAMAGED_PREPARING = 'DAMAGED_PREPARING',
  DAMAGED_READY_FOR_PICK_UP = 'DAMAGED_READY_FOR_PICK_UP',
  DAMAGED_DELIVERING = 'DAMAGED_DELIVERING',
}

export enum DamagedItemStatus {
  CANCELLED = 'CANCELLED',
  DAMAGED_CREATED = 'DAMAGED_CREATED',
  DAMAGED_PREPARING = 'DAMAGED_PREPARING',
  DAMAGED_READY_FOR_PICK_UP = 'DAMAGED_READY_FOR_PICK_UP',
  DAMAGED_DELIVERING = 'DAMAGED_DELIVERING',
  DAMAGED_DELIVERED = 'DAMAGED_DELIVERED',
  DAMAGED_CANCELLED = 'DAMAGED_CANCELLED',
}

export enum PaymentMethod {
  MOBILE_PAYMENT = 'MOBILE_PAYMENT',
  CREDIT_CARD = 'CREDIT_CARD',
}

export enum BillStatus {
  NOT_CLEARED = 'NOT_CLEARED',
  BILL_CANCELLED_AS_SHOP_CLOSED = 'BILL_CANCELLED_AS_SHOP_CLOSED',
  CLEARED = 'CLEARED',
}
